export enum EOrderAccreditationStatus {
  NOT_STARTED = 'NOT_STARTED',
  DOCUMENTS_SUBMISSION = 'DOCUMENTS_SUBMISSION',
  DOCUMENTS_RESUBMISSION = 'DOCUMENTS_RESUBMISSION',
  ARCHIVE_UNPACKING = 'ARCHIVE_UNPACKING',
  DOCUMENTS_CHECK = 'DOCUMENTS_CHECK',
  ACTIVE = 'ACTIVE',
  REJECTED = 'REJECTED',
}
